import axios from "axios";
import { eldDriverGet, eldDriversMatchingGet, eldTruckGet } from "@/api/eld";
import { formatDateTime } from "@/utils/date"

const state = {
  namespaced: true,
  state: {
    authorized: false,
    reAuthorized: false,
    authDate: null,
    apiKey: null,
    source: "",
    showDiaLog: false,
    saveState: false,
    diaLogMsg: {
      title: "",
      content: "",
      img: "",
      confirmContent: "",
    },
    driversMatchingInfo: null, // 匹配的信息
    driversGet: null, // 所有的eld的driver
    editOperate: false, // 设置匹配信息
    truck: null,
    dataSource: "eld", // 当前的数据源
  },
  mutations: {
    SET_APIKEY(state, payload) {
      state.apiKey = payload;
    },
    SET_SOURCE(state, payload) {
      state.source = payload;
    },
    SET_SHOWDIALOG(state) {
      state.showDiaLog = !state.showDiaLog;
    },
    SET_DIALOGMSG(state, payload) {
      state.diaLogMsg = payload;
    },
    SET_AUTHORIZED(state) {
      state.authorized = !state.authorized;
    },
    SET_DRIVERSMATCHINGINFO(state, payload) {
      state.driversMatchingInfo = payload;
    },
    SET_DRIVERSGET(state, payload) {
      let driversGet = payload;
      if (driversGet) {
        driversGet = payload.map(item => {
          return {
            eldDriverId: item.eldDriverId,
            eldId: item.eldId,
            eldEmail: item.email,
            eldName: item.name,
            eldPhone: item.phone,
            status: item.status
          }
        });
      }
      state.driversGet = driversGet;
    },
    SET_AUTHDATE(state, payload) {
      state.authDate = formatDateTime(payload);
    },
    SET_EDITOPERATE(state) {
      state.editOperate = !state.editOperate;
    },
    SET_SAVESTATE(state, payload) {
      state.saveState = payload;
    },
    SET_REAUTHORIZED(state, payload) {
      state.reAuthorized = payload;
    },
    SET_TRUCK(state, payload) {
      state.truck = payload;
    },
    SET_DATASOURCE(state, payload) {
      switch(payload) {
        case 1:
          payload = 'eld';
          break;
        case 2:
          payload = 'tp';
          break;
        case undefined:
          payload = 'eld';
          break;
      }
      state.dataSource = payload;
    }
  },
  actions: {
    /**
     * 获取所有eld的driver 以及 匹配的信息
     * @param {*} param0
     */
    async getDriversInfo({ commit }) {
      const results = [
        ...(await axios.all([eldDriverGet(), eldDriversMatchingGet()])).map(
          (item) => item
        ),
      ];
      commit("SET_DRIVERSGET", results[0].data);
      commit("SET_DRIVERSMATCHINGINFO", results[1].data.resList);
      commit("SET_AUTHDATE", results[1].data.integration_time);
      commit("SET_SOURCE", results[1].data.source);
      commit("SET_APIKEY", results[1].data.apiKey);
      commit("SET_DATASOURCE", results[1].data.locationSource);
    },

    async getTruckList({ commit }, payload) {
      const { res } = await eldTruckGet({
        driverId: payload
      });
      console.log(res);
      // commit("SET_TRUCK", res.data);
      commit("SET_TRUCK", null);
    }
  },
};

export default state;
